import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

// components
import { EnrollmentFrame } from './components';
import Telephony from './telephony';
import Acknowledge from './acknowledge';
import Contact from './contact';
import Coverage from './coverage';
import Eligibility from './eligibility';
import Payment from './payment';
import Attest from './attest';
import Summary from './summary';
import Other from './other';
import LoginIframe from '../awsconnect/LoginIframe';
// modals
import DoctorsModal from '../../components/modals/doctors';
import TipsModal from '../../components/modals/tips';
import ExitModal from '../../components/modals/exit';

function Enrollment() {
  const dispatch = useDispatch();
  const { baseRoute } = useSelector(store => store.form);
  const { tipsModalContent = false } = useSelector(store => store.theme);

  useEffect(() => {
    // auto show tips modal on first visit to enrollment portal, but not
    // on subsequent visits.
    setTimeout(() => {
      const hideTipsModal = localStorage.getItem('HideTipsModal');
      if (!hideTipsModal && tipsModalContent !== false) {
        localStorage.setItem('HideTipsModal', true);
        dispatch({ type: 'OPEN_MODAL', modal: 'tipsModal' });
      }
    }, 1000);
  }, []);

  return (
    <>
      <DoctorsModal />
      <TipsModal />
      <ExitModal />
      <LoginIframe />

      <Routes>
        <Route
          path={`${baseRoute}/telephony/*`}
          element={(
            <EnrollmentFrame>
              <Telephony />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/acknowledge/*`}
          element={(
            <EnrollmentFrame>
              <Acknowledge />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/contact/*`}
          element={(
            <EnrollmentFrame>
              <Contact />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/coverage/*`}
          element={(
            <EnrollmentFrame>
              <Coverage />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/eligibility/*`}
          element={(
            <EnrollmentFrame>
              <Eligibility />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/payment/*`}
          element={(
            <EnrollmentFrame>
              <Payment />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/attest/*`}
          element={(
            <EnrollmentFrame>
              <Attest />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/summary/*`}
          element={(
            <EnrollmentFrame>
              <Summary />
            </EnrollmentFrame>
          )}
        />
        <Route
          path={`${baseRoute}/other/*`}
          element={(
            <EnrollmentFrame>
              <Other />
            </EnrollmentFrame>
          )}
        />
      </Routes>
    </>
  );
}

export default Enrollment;
